module.exports = __webpack_public_path__ + "static/media/friend_icon.c0ad8455.svg";